module.exports = __webpack_public_path__ + "img/edit_icon.ab5e1e59.svg";